(function () {
  'use strict';
  function init(root) {
    root.querySelectorAll('[data-ps-shipping-estimate]').forEach(function (panel) {
      if (panel.dataset.psReady) return;
      panel.dataset.psReady = 'true';
      var country = panel.querySelector('[data-ps-country]');
      var province = panel.querySelector('[data-ps-province]');
      var postcode = panel.querySelector('[data-ps-postcode]');
      var result = panel.querySelector('[data-ps-estimate-result]');
      var button = panel.querySelector('[data-ps-estimate-button]');
      Array.from(country.options).forEach(function (option) { if (!['Australia','New Zealand'].includes(option.value)) option.remove(); });
      country.value = panel.dataset.defaultCountry;
      if (!country.value && country.options.length) country.selectedIndex = 0;
      var revision = 0;
      var loading = false;
      function provinces() {
        var options = [];
        try { options = JSON.parse(country.selectedOptions[0].dataset.provinces || '[]'); } catch (_) {}
        province.replaceChildren();
        options.forEach(function (values) { var option = document.createElement('option'); option.value = values[0]; option.textContent = values[1]; province.appendChild(option); });
        panel.querySelector('[data-ps-province-field]').hidden = !options.length;
      }
      function clear() { revision++; result.replaceChildren(); }
      country.addEventListener('change', function () { provinces(); clear(); });
      province.addEventListener('change', clear); postcode.addEventListener('input', clear);
      provinces();
      button.addEventListener('click', async function () {
        if (loading) return;
        result.replaceChildren();
        if (!/^\d{4}$/.test(postcode.value.trim())) { result.textContent = 'Enter a four-digit postcode to get an estimate.'; postcode.focus(); return; }
        if (!['Australia','New Zealand'].includes(country.value)) { result.textContent = 'Choose Australia or New Zealand.'; return; }
        var requestRevision = revision;
        var params = new URLSearchParams();
        params.set('shipping_address[country]', country.value);
        params.set('shipping_address[province]', province.value || '');
        params.set('shipping_address[zip]', postcode.value.trim());
        loading = true; button.disabled = true; button.textContent = 'Getting your estimate…';
        result.textContent = 'Checking available delivery services…';
        try {
          var rootUrl = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
          var response = await fetch(rootUrl + 'cart/shipping_rates.json?' + params.toString(), {headers: {Accept:'application/json'}});
          var body = await response.json();
          if (revision !== requestRevision) return;
          if (!response.ok || !Array.isArray(body.shipping_rates)) throw new Error('Please check the address, or continue to checkout for delivery options.');
          result.replaceChildren();
          if (!body.shipping_rates.length) { result.textContent = 'No delivery services were returned for this cart and address. Check the details or contact us.'; return; }
          var label = document.createElement('p'); label.textContent = 'Available for ' + postcode.value.trim() + ', ' + country.value + ':';
          var list = document.createElement('ul');
          body.shipping_rates.forEach(function (rate) {
            var price = Number(rate.price);
            if (!Number.isFinite(price) || price < 0) return;
            var item = document.createElement('li'), name = document.createElement('span'), value = document.createElement('strong');
            name.textContent = rate.name;
            var currency = rate.currency || panel.dataset.currency || 'AUD';
            value.textContent = new Intl.NumberFormat('en-AU', {style:'currency',currency:currency}).format(price) + ' ' + currency;
            item.append(name,value); list.appendChild(item);
          });
          if (!list.children.length) throw new Error('Rates could not be read. Continue to checkout for an exact quote.');
          result.append(label,list);
        } catch (error) {
          if (revision === requestRevision) result.textContent = error.message || 'Delivery estimates are unavailable right now. Checkout can still show your options.';
        } finally { loading = false; button.disabled = false; button.textContent = 'Get delivery estimate'; }
      });
      // Rates refer to the current cart. Clear a previous quote when quantities change.
      ['cart:updated','cart:refresh'].forEach(function (name) { document.addEventListener(name, clear); });
      document.addEventListener('click', function (event) { if (event.target.closest('cart-remove-button, .js-addtocart-page')) clear(); });
      document.addEventListener('change', function (event) { if (event.target.matches('input[name="updates[]"], .cart-item__quantity-input')) clear(); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('cart:updated', function () { queueMicrotask(function () { init(document); }); });
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
}());
